import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ForceSaveToothEditorService {
	forceSaveToothEditor$ = new BehaviorSubject<boolean>(false);
}
